// extracted by mini-css-extract-plugin
module.exports = {"h1":"H1_h1__DYadl","h1--multiline":"H1_h1--multiline__TP6kH","h1__input":"H1_h1__input__Lf7xR","h1__label":"H1_h1__label__wJz77","h1__label--filled":"H1_h1__label--filled__dXyJC"};